"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFooterBlock = void 0;
var blockinfo_1 = require("../blockinfo");
var isFooterBlock = function (f) {
    return [blockinfo_1.BlockType.Footer, blockinfo_1.BlockType.FooterWidget].includes(f.blockType);
};
exports.isFooterBlock = isFooterBlock;
